import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { Icon } from '@stereograph/teia-system-design/components/Icon';
import { IconButton } from '@stereograph/teia-system-design/components/IconButton';
import { usePluginTranslation } from '@translation';
import { useAnomalyDocumentContext } from '../../context/AnomalyDocumentContext';
import { useDownloadDocument } from '../../hooks/useDownloadDocument';

export const AnomalyDocumentCardDownload = () => {
  const { anomalyDocument } = useAnomalyDocumentContext();
  const { download } = useDownloadDocument();
  const { t } = usePluginTranslation();

  return (
    <IconButton
      onClick={() => download(anomalyDocument)}
      aria-label={t('anomaly_plugin.document.download_label')}
      iconOnly
      data-dd-action-name="tvp.anomaly.document.download"
    >
      <Icon component={ArrowDownTrayIcon} fontSize="small" />
    </IconButton>
  );
};
